if (!customElements.get('pp-devis-standard')) {
  class PPDevisStandard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));

      const checkedIntent = this.querySelector('[data-pp-intent-radio]:checked');
      if (checkedIntent) {
        this.updateIntent(checkedIntent.dataset.ppIntentRadio, false);
      }

      const success = this.querySelector('[data-pp-form-success]');
      if (success && window.location.hash.includes('PPDevisForm-')) {
        requestAnimationFrame(() => success.focus());
      }
    }

    handleClick(event) {
      const thumbnail = event.target.closest('[data-pp-media-target]');
      if (thumbnail && this.contains(thumbnail)) {
        this.selectMedia(thumbnail.dataset.ppMediaTarget);
        return;
      }

      const intentTrigger = event.target.closest('[data-pp-intent]');
      if (intentTrigger && this.contains(intentTrigger)) {
        this.selectIntent(intentTrigger.dataset.ppIntent, true);
        return;
      }

      const intentChange = event.target.closest('[data-pp-intent-change]');
      if (intentChange && this.contains(intentChange)) {
        this.unlockIntent();
      }
    }

    handleChange(event) {
      const radio = event.target.closest('[data-pp-intent-radio]');
      if (radio && radio.checked) {
        this.updateIntent(radio.dataset.ppIntentRadio);
      }
    }

    selectMedia(mediaId) {
      this.querySelectorAll('[data-pp-media-panel]').forEach((panel) => {
        const isSelected = panel.dataset.ppMediaPanel === mediaId;
        panel.hidden = !isSelected;

        if (!isSelected) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
        }
      });

      this.querySelectorAll('[data-pp-media-target]').forEach((button) => {
        const isSelected = button.dataset.ppMediaTarget === mediaId;
        button.classList.toggle('is-active', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });
    }

    selectIntent(intent, lockSelection = false) {
      const radio = this.querySelector(`[data-pp-intent-radio="${intent}"]`);
      if (!radio) return;

      radio.checked = true;
      this.updateIntent(intent);

      if (lockSelection) {
        this.lockIntent(intent);
      }
    }

    updateIntent(intent, announce = true) {
      this.dataset.selectedIntent = intent;

      this.querySelectorAll('[data-pp-conditional]').forEach((fieldGroup) => {
        const isActive = fieldGroup.dataset.ppConditional === intent;
        fieldGroup.hidden = !isActive;

        fieldGroup.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !isActive;
        });
      });

      const message = this.querySelector('[data-pp-placeholder-devis]');
      if (message) {
        const placeholder = intent === 'etude'
          ? message.dataset.ppPlaceholderEtude
          : message.dataset.ppPlaceholderDevis;
        if (placeholder) message.placeholder = placeholder;
      }

      const submitLabel = this.querySelector('[data-pp-submit-label]');
      if (submitLabel) {
        const label = intent === 'etude'
          ? submitLabel.dataset.etudeLabel
          : submitLabel.dataset.devisLabel;
        if (label) submitLabel.textContent = label;
      }

      const visibleLabel = this.querySelector(`[data-pp-intent-label="${intent}"]`);
      const summaryText = this.querySelector('[data-pp-intent-summary-text]');
      if (visibleLabel && summaryText) {
        summaryText.textContent = visibleLabel.textContent.trim();
      }

      if (announce && visibleLabel) {
        const status = this.querySelector('[data-pp-intent-status]');
        if (status) status.textContent = visibleLabel.textContent.trim();
      }
    }

    lockIntent(intent) {
      const options = this.querySelector('[data-pp-intent-options]');
      const summary = this.querySelector('[data-pp-intent-summary]');
      if (!options || !summary) return;

      this.updateIntent(intent, false);
      options.hidden = true;
      summary.hidden = false;
    }

    unlockIntent() {
      const options = this.querySelector('[data-pp-intent-options]');
      const summary = this.querySelector('[data-pp-intent-summary]');
      if (!options || !summary) return;

      summary.hidden = true;
      options.hidden = false;

      const checked = options.querySelector('[data-pp-intent-radio]:checked');
      if (checked) checked.focus();
    }
  }

  customElements.define('pp-devis-standard', PPDevisStandard);
}
